export default {"src":"/_next/static/media/menu-icon.409f1d78.svg","height":17,"width":25,"blurWidth":0,"blurHeight":0};